import { useNavigate } from 'react-router-dom'
import { useGetIdentity } from '@refinedev/core'
import { Avatar, Layout as AntdLayout, Select, Space, Typography } from 'antd'

import { defaultShadow } from '../theme'
import { I18N_GENERIC_NS } from '../i18n'
import { useTranslation } from 'react-i18next'
import { useViewAs } from '../contexts/viewAs'
import { useEntitySelectorProps } from '../components/selects/entitySelectors'

const { Text } = Typography

const investorLabel = r =>
	[[r.first_name, r.last_name].filter(Boolean).join(' '), r.passport_name].filter(Boolean).join(' — ') ||
	r.email ||
	r.id

const ProfileCard = ({ investorId, fullName, additional_role, avatarSrc }) => {
	const navigate = useNavigate()

	const { t } = useTranslation([I18N_GENERIC_NS])

	const src = avatarSrc || (investorId && `${process.env.REACT_APP_BOT_API_URL}/investors/${investorId}/avatar?${Date.now()}`)

	return (
		<Space
			size='middle'
			onClick={() => navigate('settings/profile')}
			style={{ width: 185, display: 'flex', alignItems: 'center', cursor: 'pointer' }}
		>
			{src && <Avatar src={src} style={{ height: 35, width: 35, border: null }} />}
			<div
				style={{
					height: 32,
					display: 'flex',
					margin: '0 1px 1px 0',
					flexDirection: 'column',
					justifyContent: 'space-between'
				}}
			>
				{fullName && <Text style={{ fontSize: 12, fontWeight: 700, lineHeight: '14px' }}>{fullName}</Text>}
				<Text style={{ fontSize: 11, fontWeight: 700, lineHeight: '14px' }}>
					{t(additional_role || 'investor')}
				</Text>
			</div>
		</Space>
	)
}

const ViewAsPicker = ({ viewAs, onSelect }) => {
	// show only investors who have at least one investment
	const selectProps = useEntitySelectorProps({
		resource: 'investors',
		nameFactory: investorLabel,
		filters: [{ field: 'has_investments', operator: 'eq', value: true }]
	})

	return (
		<Select
			{...selectProps}
			showSearch
			labelInValue
			filterOption={false}
			style={{ width: 260 }}
			size='small'
			placeholder='Search by name / passport'
			value={viewAs ? { value: viewAs.id, label: viewAs.name } : undefined}
			onChange={opt => onSelect({ id: opt.value, name: opt.label })}
		/>
	)
}

const Header = () => {
	const { data, fetchStatus } = useGetIdentity()
	const { investor_id, full_name, team_member_of_investor_id, is_admin, picture } = data || {}
	const { viewAs, setViewAs } = useViewAs()

	const additional_role = is_admin ? 'admin' : team_member_of_investor_id && 'team_member'

	return (
		<AntdLayout.Header
			style={{
				height: '64px',
				gap: '24px',
				display: 'flex',
				padding: '0px 24px',
				alignItems: 'center',
				backgroundColor: 'white',
				boxShadow: defaultShadow,
				justifyContent: 'flex-end'
			}}
		>
			{is_admin && (
				<Space size='small'>
					<Text style={{ fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap' }}>Viewing For:</Text>
					<ViewAsPicker viewAs={viewAs} onSelect={setViewAs} />
				</Space>
			)}
			{/* fetchStatus is used to force update of avatar */}
			{fetchStatus === 'idle' && (
				<ProfileCard
					investorId={investor_id}
					fullName={full_name}
					additional_role={additional_role}
					avatarSrc={picture}
				/>
			)}
		</AntdLayout.Header>
	)
}

export default Header
